import _ from '@strings'
import { Row, Column } from '@components/Ui/Grid'
import Text from '@components/Ui/Text'
import config from '@config'
import styles from './NoAppointment.scss'

const NoAppointment = () => (
  <div className={styles.base}>
    <Row>
      <Column size="12/12@md">
        <Text as="div" type="robo_md_bold">
          {_('appointment_missing.headline')}
        </Text>
        <Text as="div" type="robo_md" html>
          {_('appointment_missing.text')}
        </Text>
        <Text as="div" type="robo_md_bold">
          <a href={config.get('local.contactFormLink')} target="_blank" rel="noreferrer">
            {_('appointment_missing.button')}
          </a>
        </Text>
      </Column>
    </Row>
  </div>
)

NoAppointment.defaultProps = {}
NoAppointment.propTypes = {}

export default NoAppointment
